"use strict";
/*
 * Copyright (C) 2024 Klaus Reimer <k@ailis.de>
 * See LICENSE.md for licensing information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapRenderOrder = void 0;
/** Map render order. */
var MapRenderOrder;
(function (MapRenderOrder) {
    /** Default right-down render order. */
    MapRenderOrder["RIGHT_DOWN"] = "right-down";
    /** Right-up render order. */
    MapRenderOrder["RIGHT_UP"] = "right-up";
    /** Left-down render order. */
    MapRenderOrder["LEFT_DOWN"] = "left-down";
    /** Left-up render order. Currently only supported for orthogonal maps. */
    MapRenderOrder["LEFT_UP"] = "left-up";
})(MapRenderOrder || (exports.MapRenderOrder = MapRenderOrder = {}));
//# sourceMappingURL=MapRenderOrder.js.map